import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
    selector: 'p-field-date-range',
    template: `
        <p-field [isMandatory]="isMandatory" [label]="label" [labelTooltip]="labelTooltip" [isReadOnly]="isReadOnly">
            <div slot="editMode">
                <mat-form-field class="p-daterange p-datepicker p-input-text" appearance="fill">
                    <mat-date-range-input [rangePicker]="picker" class="p-input-text-input" [class.filled]="isFilled || value?.to">
                        <input
                            matStartDate
                            [attr.aria-label]="'Start date'"
                            autocomplete="off"
                            readonly
                            [value]="value?.from"
                            class="p-input-text-input-ellipsis"
                            (click)="openDatepicker()"
                            (focus)="openDatepicker()"
                            (dateChange)="changeValue($event, 'from')"
                        />
                        <input
                            matEndDate
                            #inputEndDate
                            [attr.aria-label]="'End date'"
                            autocomplete="off"
                            readonly
                            [value]="value?.to"
                            class="p-input-text-input-ellipsis"
                            (click)="openDatepicker()"
                            (focus)="openDatepicker()"
                            (dateChange)="changeValue($event, 'to')"
                        />
                    </mat-date-range-input>
                    <p-icon class="p-field-input-icon" [class.shown]="isOpened" name="calendar" size="sm"></p-icon>
                    <mat-date-range-picker #picker (closed)="streamClosed()" panelClass="p-datepicker-panel"></mat-date-range-picker>
                </mat-form-field>
            </div>
        </p-field>
    `,
    styleUrls: ['./p-field-date-range.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldDateRangeComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldDate'
})
export class PFieldDateRangeComponent extends PFieldAbstractComponent<DateRange> {
    @Input() label?: string;

    @Input() isMandatory = false;

    @ViewChild('picker') picker: MatDatepicker<Date> = {} as MatDatepicker<Date>;
    @ViewChild('inputEndDate') inputEndDate: ElementRef = {} as ElementRef;
    public isOpened = false;
    public isFilled = false;

    @Input() override value: DateRange = {} as DateRange;

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    override writeValue(obj: any): void {
        if (obj == null) {
            this.value = { from: null, to: null };
        } else {
            this.value = obj;
        }
    }

    changeValue(ev: MatDatepickerInputEvent<any>, controlName: string) {
        this.markAsTouched();
        if (!this.isReadOnly) {
            this.value[controlName as keyof DateRange] = ev.value;
            this._onChange(this.value);
        }
    }

    openDatepicker(): void {
        this.isOpened = true;
        this.picker.open();
    }

    streamClosed(): void {
        this.inputEndDate.nativeElement.value ? (this.isFilled = true) : (this.isFilled = false);
        this.isOpened = false;
    }
}

interface DateRange {
    from: Date | null;
    to: Date | null;
}
